<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Autorização de Suporte</h5>
                <hr>

				<DataTable :value="empresas" class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">	
								<InputText v-model="valorBusca" placeholder="Nome Fantasia..." @keyup.enter="buscar" style="width: 100%;"/>
								<Button label="Buscar" icon="pi pi-search" class="p-ml-2" @click="buscar" />
							</div>
						</div>
					</template>	
					<Column field="id" header="Id" sortable></Column>			
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="cnpj" header="CNPJ/CPF" sortable>
						<template #body="slotProps">
							<label v-if="slotProps.data.tipoNumeroDocumento == 'cnpj'">
								{{ slotProps.data.cnpj | maskCNPJ }}
							</label>
							<label v-else>
								{{ slotProps.data.cnpj | maskCPF }}
							</label>							
						</template>
					</Column>				
					<Column field="seguimento" header="Segmento" sortable></Column>
					<Column field="dataCadastro" header="Cadastro" sortable></Column>
					<Column field="idRevendedor" header="Revendedor" sortable></Column>	
					<Column field="status" header="Status" sortable>
						<template #body="slotProps">                                    
							<div>   							                                     
								<span class="p-badge p-badge-lg p-badge-danger" title="Cliente Bloqueado" v-if="slotProps.data.status == 2" >
									<i style="color:#F9B720" class="pi pi-lock" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-secondary" title="Cliente Inativo" v-else-if="slotProps.data.status == 0" >
									<i class="pi pi-power-off" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-success" title="Cliente Ativo" v-else>                                          
									<i class="pi pi-lock-open"></i>
								</span>                                        
							</div>
						</template>
					</Column>					
					<Column header="">
						<template #body="slotProps">							
							<Button icon="pi pi-users" title="Suporte" class="p-button-rounded p-button-help" label="Suporte" @click="suporte(slotProps.data.id)"/>							
						</template>
					</Column>
				</DataTable>	
				
				<Paginator :rows="totalPorPagina" :totalRecords="totalItens" :rowsPerPageOptions="[15, 25, 30]" 
					template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" 
					currentPageReportTemplate="Listando {first} de {last} de {totalRecords}" 
					@page="paginar($event)"/> 

			</div>
		</div>
	</div>
</template>

<script>
import AutorizacaoSuporteService from '@/service/AutorizacaoSuporteService';
import EmpresaService from '@/service/EmpresaService';
import Cnpj from '@/model/Cnpj';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	autorizacaoSuporteService: null,
	empresaService: null,
	data() {
		return {				
			cnpj: new Cnpj(),	
			cnpjs: [],		
			diasInicio: [],
			diasFinal: [],
			empresa: {},
            empresas: [],
			totalItens: 0,
			totalPorPagina: 15,
			pagina: 0,
			valorBusca: ''
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
		/**
         * 
         */
        paginar(event) {
            this.pagina = event.page;
            this.listar();
        },
		/**
		 * 
		 */	
		buscar() {
			this.pagina = 0;
			this.totalPorPagina = 15;
			this.listar();
		},
		/**
		 * 
		 */
		listar() {			
			this.empresaService.listar(this.valorBusca, this.pagina, this.totalPorPagina)
			.then(resp => {			
				this.totalItens = resp.data.totalItens;
				this.empresas = resp.data.empresas;					
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},		
		/**
		 * 
		 */
		suporte(id) {			
			const email = this.getDadosRequisicao().usuario.email;
            this.autorizacaoSuporteService.autorizar(id, email)
			.then(resp => {	   
				const auto = resp.data;
                let url = process.env.VUE_APP_BASE_URL_FRONTEND_IKPONTO+'?_ref='+auto.id+'&_aut='+auto.autorizacao+'&_refacesso='+auto.refAcesso;	
				console.log(url)
                window.open(url, '_blank');				
			})
			.catch(erro => {exibirMensagem(this, erro)});   
		}
	},	
	created() {
		this.autorizacaoSuporteService = new AutorizacaoSuporteService();
		this.empresaService = new EmpresaService();		
	},
}
</script>

<style scoped>
</style>